__webpack_require__.p = "/bsw-game/";